module.exports = __webpack_public_path__ + "static/media/zumkha-overview.7af233d0.png";